import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'

const DoctorWomanOutline = createIcon({
  displayName: 'DoctorWomanOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <line
        x1="14.10099"
        y1="13.405"
        x2="14.99999"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.90099"
        y1="13.405"
        x2="8.99999"
        y2="16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,21V19.54138A3,3,0,0,1,5.5068,16.5822L9,16a4.24265,4.24265,0,0,0,6,0l3.4932.5822A3,3,0,0,1,21,19.54138V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19,16.71442V8.5a7,7,0,0,0-7-7h0a7,7,0,0,0-7,7v8.21443"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16,8h0a3.23607,3.23607,0,0,1-2.89442-1.78885L13,6v.00011A3.61807,3.61807,0,0,1,9.764,8.00006l-1.764,0V10a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="7.99999"
        y1="16.16667"
        x2="7.99999"
        y2="19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="7.99999"
        cy="20.5"
        r="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="15.99999"
        y1="16.16667"
        x2="15.99999"
        y2="19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.27752,22A1.99265,1.99265,0,0,1,14,21h0a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2h0a1.99276,1.99276,0,0,1-.27753,1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const DoctorWomanTwoTone = createIcon({
  displayName: 'DoctorWomanTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        d="M19,16.71442V8.5a7,7,0,0,0-7-7h0a7,7,0,0,0-7,7v8.21443"
        fill="twoToneLightColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="line"
        x1="14.10099"
        y1="13.405"
        x2="14.99999"
        y2="16"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="line"
        x1="9.90099"
        y1="13.405"
        x2="8.99999"
        y2="16"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M3,21V19.54138A3,3,0,0,1,5.5068,16.5822L9,16a4.24265,4.24265,0,0,0,6,0l3.4932.5822A3,3,0,0,1,21,19.54138V21"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

      <Box
        as="path"
        d="M16,8h0a3.23607,3.23607,0,0,1-2.89442-1.78885L13,6v.00011A3.61807,3.61807,0,0,1,9.764,8.00006l-1.764,0V10a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4Z"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="line"
        x1="7.99999"
        y1="16.16667"
        x2="7.99999"
        y2="19"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="7.99999"
        cy="20.5"
        r="1.5"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="line"
        x1="15.99999"
        y1="16.16667"
        x2="15.99999"
        y2="19"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M14.27752,22A1.99265,1.99265,0,0,1,14,21h0a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2h0a1.99276,1.99276,0,0,1-.27753,1"
        fill="light"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const DoctorWoman: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={DoctorWomanTwoTone} {...props} />
  return <CustomIcon as={DoctorWomanOutline} {...props} />
}

export default memo(DoctorWoman)
